import { api } from '@app/config/axios';
import { getApiError } from '@shared/helpers/get-api-error';
import { CommonListQueryParams } from '@shared/types/list-params';

export type GetPendingTranfers = {
  count: number;
  data: Array<{
    id: string;
    requesterName: string;
    oldCongregation: string;
    newCongregation: string;
    date: string;
    sameSetor: boolean;
  }>;
  limit: number;
  page: number;
};

type GetTransferLetterResponse = {
  url: string;
};

type DeclineCongregationTransferPutParams = {
  requestId: string;
  justification: string;
};

export async function getPendingTranfersService(
  params: CommonListQueryParams,
): Promise<GetPendingTranfers> {
  const response = await api.get('/congregation/change/list', { params });

  return response.data;
}

export async function declineCongregationTranferService(
  params: DeclineCongregationTransferPutParams,
) {
  try {
    await api.put(`/congregation/change/${params.requestId}/declined`, {
      justification: params.justification,
    });
  } catch (error) {
    getApiError(
      error,
      'Tivemos problemas internos ao rejeitar essa solicitação',
    );
  }
}

export async function acceptCongregationTranferService(
  requestId: string,
): Promise<{
  url: string;
}> {
  try {
    const response = await api.put(`/congregation/change/${requestId}/accept`);
    return response.data;
  } catch (error) {
    getApiError(
      error,
      'Tivemos problemas internos ao aceitar essa solicitação',
    );

    throw error;
  }
}

export async function getTransferLetter(
  letterId: string,
): Promise<GetTransferLetterResponse> {
  const response = await api.get(`/congregation/letter/${letterId}`);
  return response.data;
}
